import { parseCatalogChannelBase } from '@wix/wix-vod-api/parsers';

export const parseCatalogChannel = parseCatalogChannelBase;
